import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription, combineLatest, merge } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DropdownService } from 'src/app/services/dropdown.service';
import { Classification } from '../../models/classification';
import { IncidentService } from 'src/app/services/incident.service';
import { LoadingService } from 'src/app/services/loading.service';
import { FormService } from 'src/app/services/form.service';
import { MatLegacyAutocompleteActivatedEvent as MatAutocompleteActivatedEvent } from '@angular/material/legacy-autocomplete';
import { DialogService } from 'src/app/services/dialog.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';




@Component({
  selector: 'app-incident',
  templateUrl: './incident.component.html',
  styleUrls: ['./incident.component.scss']
})
export class IncidentComponent implements OnInit {
  @Input() form: FormGroup;
  classificationData: Array<Classification> = [];
  user = JSON.parse(window.sessionStorage.getItem('userInfo'));

  constructor(
    private dropdownService: DropdownService,
    private incidentService: IncidentService,
    private formService: FormService,
    private dialogService: DialogService,
    private loader: LoadingService,
    private toast: ToastService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  get isMalfunctionType(): boolean {
    return (
      this.form.get('classificationId').value === 1 &&
      this.form.get('classificationTypeId').value === 1 &&
      this.form.get('categoryId').value === 1
    );
  }

  get isInserviceOrInspectionError(): boolean {
    return (
      this.form.get('classificationId').value === 1 &&
      this.form.get('classificationTypeId').value === 3 &&
      this.form.get('categoryId').value === 27
    );
  } 

  readonly madbIncidentsDisplay = (incident: any): string =>
    incident ? `${incident?.incidentName} | ${incident?.baseCode}` : '';

  readonly aircraftDisplay = (aircraft: any): string => 
    aircraft ? (aircraft.Aircraft_Name +  ' | ' +  aircraft.Aircraft_Tail_Number + ' | ' +  aircraft.homeBase) : '';
  aircrafts$: Observable<any> = this.dropdownService
  .getAircrafts()
  .pipe(map((response) => response.value));
  aircrafts = [];
  filteredAircafts$: Observable<any[]>;
  aircraftsSubscription: Subscription;
  selectedAircraftSub: Subscription;
  aircraftsSub: Subscription;
  
  loading$ = this.loader.loading$;
  madbIncidentCtrl = new FormControl();

  madbIncidentList: any;
  madbIncidentListSub: Subscription;
  madbIncidentSubscription: Subscription;

  homeBases$ = this.dropdownService.getMadbHomeBases();
  homeBases: any;
  homeBasesSub: Subscription;
  classifications$ = this.dropdownService.getClassifications();
  areas$ = this.dropdownService.getAreas();
  malfunctionTypes$ = this.dropdownService.getMalfunctionTypes();
  spikeBases$: Observable<any>;

  categories$: BehaviorSubject<Classification[]> = new BehaviorSubject<Classification[]>([]);

  classficationSub: Subscription;
  homeBaseSub: Subscription;

  madbIncidentSub: Subscription;
  aircraftSub: Subscription;

  spikeBases: any;
  spikebaseSub: Subscription;

  jumperSubscription: Subscription;
  jumperSub: Subscription;

  malfunctionTypeSub: Subscription;

  modes = [
    'Proficiency / Training Jump',
    'Fire Jump',
    'Single Resource',
    'Ground Crew / Pounder',
    'Booster In',
    'Booster Out',
    'Point To Point',
    'Preposition',
    'Dry Run',
    'Other Jump',
    'Rescue Jump',
    'Paracargo',
    'Admin Detail',
    'Recon/Patrol',
    'On Jump List',
    'Demobilization',
    'Training',
    'Other',
    'Day Off',
    'Evaluation Jump'
  ];

  missions = [
    'Training',
    'Wildland Fire',
    'Prescribed Fire',
    'Mech Fuels Treatment',
    'Structure Protection',
    'Logistics',
    'Fire Suppression',
    'Other Action'
  ];

  yardsOfDrift = [
    0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 750, 800, 850, 900, 950,
    1000, 1050, 1100, 1150, 1200
  ];

  modal = {
    active: false,
    data: {}
  };
  deleteIncidentSub: Subscription;
  statusSub: Subscription;
  elevationSub: Subscription;
  areaSub: Subscription;
  areasSub: Subscription;


  ngOnInit(): void {
    // these are all the moved aircraft related code
    this.filteredAircafts$ = this.form.get('aircraft').valueChanges.pipe(
      startWith(''),
      map((value) => this._filterAircrafts(value || ''))
    );

    this.aircraftsSub = this.dropdownService.getAircrafts().subscribe({
      next: (aircrafts) => {
        this.aircrafts = aircrafts.value;
        this.filteredAircafts$ = this.form.get('aircraft').valueChanges.pipe(
          startWith(''),
          map((value) => this._filterAircrafts(value || ''))
        );
      }
    })

    // here we subscribe to any changes in the form jumpSpotElevationMSL and convert it to local string
    this.elevationSub = this.form.get('jumpSpotElevationMSL').valueChanges.subscribe((elevation) => {
      if (elevation) {
        this.form.get('jumpSpotElevationMSL').patchValue(elevation.toLocaleString(), { emitEvent: false });
      }
    });
    // here we subscribe to any changes in the form status and disable the madbIncidentCtrl if the status is 1
    this.statusSub = this.form.get('status').valueChanges.subscribe((status) => {
      if (status === 1) {
        this.madbIncidentCtrl.disable();
      } else {
        this.madbIncidentCtrl.enable();
      }
    });

    // here we make sure thie initial madb list is populated for the dropdown
    this.incidentService.getMadbIncidentsFilteredByString('a')
    this.madbIncidentListSub = this.incidentService.madbIncidentList.subscribe((madbIncidents) => {
      // this limits the list to 100 items for performance reasons in the ui dropdown
      this.madbIncidentList = madbIncidents?.slice(0, 100);
    })

    const classificationControls$ = combineLatest([
      this.form.get('classificationId').valueChanges,
      this.form.get('classificationTypeId').valueChanges
    ]);

    this.classficationSub = classificationControls$.subscribe((controlValues) => {
      if (controlValues[0] !== null && controlValues[1] !== null) {
        this.classifications$
          .pipe(
            map((classifications) =>
              this.categories$.next(
                classifications.filter(
                  (classification) =>
                    classification.classificationId === controlValues[0] &&
                    classification.classificationTypeId === controlValues[1]
                )
              )
            )
          )
          .subscribe();
        this.form.get('categoryId').enable({ emitEvent: false });
      }
    });
    
    if (this.route.snapshot.params.id) {
      this.formService.marsMadbIncident.subscribe((value) => {
        // this connects our form to the madb incident form
        this.madbIncidentCtrl.patchValue(value);
      });
    }

    // here we subscribe to any changes in madbIncidentId, if it isn't null, we disable the mission, mode, area, yardsDrift, and aircraft fields
    this.madbIncidentSubscription = this.form.get('madbIncidentId').valueChanges.subscribe((id) => {
      if (id) {
        this.form.get('mission').disable();
        this.form.get('mode').disable();
        this.form.get('toArea').disable();
        this.form.get('yardsDrift').disable();
        this.form.get('aircraft').disable();
      } else {
        this.form.get('mission').enable();
        this.form.get('mode').enable();
        this.form.get('toArea').enable();
        this.form.get('yardsDrift').enable();
        this.form.get('aircraft').enable();
      }
    });

    this.homeBaseSub = this.form.get('homeBase1').valueChanges.subscribe((controlValue) => {
      if(controlValue && !this.form.get('homeBase1Details')?.value) {
        this.homeBases$.forEach((bases) => {
          const base = bases.find((base: any) =>  this.form.get('homeBase1').value === base.baseCode )
        })
      }
      this.form.get('spikeBaseId').enable({ emitEvent: false });
      this.spikeBases$ = this.dropdownService
        .getSpikeBases(controlValue)
        .pipe(map((response) => response.value));
      this.spikebaseSub = this.dropdownService.getSpikeBases(controlValue).subscribe((bases) => {
        this.spikeBases = [{name: '', id: 0}, ...bases.value];
        const base = bases?.value?.find((base) => base.id === this.form.get('spikeBaseId').value);
        this.form.get('spikeBaseDetails').patchValue(base, { emitEvent: false });
      });
    });

    this.homeBasesSub = this.dropdownService.getMadbHomeBases().subscribe((bases) => {
      this.homeBases = bases;
    });

    this.homeBaseSub = this.form.get('homeBaseId').valueChanges.subscribe((homeBaseId) => {
      let chosenBase;
      this.homeBases$.forEach((bases) => {
        chosenBase = bases.find((base: any) =>  homeBaseId === base.id )
        this.form.get('homeBase1Details').patchValue(chosenBase);
        if(!chosenBase) {
          this.dropdownService.getBaseById(homeBaseId).subscribe((base) => {
            chosenBase = base;
            chosenBase.value = base.code
            chosenBase.baseCode = base.code
            chosenBase.text = base.name
            chosenBase.baseId = base.id
            this.homeBases.push(base);
            this.form.get('homeBase1Details').patchValue(chosenBase);
          })
        }
      })
      if(chosenBase) {
        this.form.get('spikeBaseId').enable({ emitEvent: false });
        this.spikeBases$ = this.dropdownService
          .getSpikeBases(chosenBase.baseCode)
          .pipe(map((response) => response.value));
        
        this.spikebaseSub = this.dropdownService.getSpikeBases(chosenBase.code).subscribe((bases) => {
          this.spikeBases = bases;
            const base = bases?.value?.find((base) => base.id === this.form.get('spikeBaseId').value);
          this.form.get('spikeBaseDetails').patchValue(base, { emitEvent: false });
        });
      }
    });

    
    // here we listen to the forms toArea for changes, and set the form toAreaName to the name of the area selected
    this.areaSub = this.form.get('toArea').valueChanges.subscribe((area) => {
      if (area === 0) {
        this.form.get('toAreaName').patchValue(null);
        return;
      } 
      
      if (area) {
        // check the type of area, if it is a string, convert it to a number
        if (typeof area === 'string') {
          area = parseInt(area);
          this.form.get('toArea').patchValue(area);
        }

        this.areasSub = this.areas$.subscribe((areas) => {
          let parsedArea = parseInt(this.form.get('toArea').value)
          const chosenArea = areas.find((areaIteration) => areaIteration.id === parsedArea);
          this.form.get('toAreaName').patchValue(chosenArea?.text);
        })
      }
    });
  }

  onAircraftChange(event: any) {
    this.form.get('travelModeId').patchValue(event.id);
    // here we find the aircraft object from the list of aircraft by checking the aircraft id against the event.value
    this.selectedAircraftSub = this.aircrafts$.subscribe((aircrafts) => {
      const aircraft = aircrafts?.filter((aircraft) => aircraft.id === event.id)[0] || null;
      this.form.get('aircraft')?.patchValue(aircraft);
    })
  }

  private _filterAircrafts(value: any): string[] {
    const filterValue = value?.toString().toLowerCase();
    
    return this.aircrafts.filter(
      (aircraft: any) =>
      aircraft?.homeBase?.toLowerCase().includes(filterValue) ||
      aircraft?.Aircraft_Name?.toLowerCase().includes(filterValue) ||
      aircraft?.Aircraft_Tail_Number?.toLowerCase().includes(filterValue)
      );
    }

  updateJumpElevation(event: any) {
    this.form.get('jumpSpotElevationMSL').patchValue(event?.target.value.toLocaleString(), { emitEvent: false });    
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString();
  }

  onMalfunctionTypeChange(event: any) {
    this.malfunctionTypeSub = this.malfunctionTypes$.subscribe((malfunctionTypes) => {
      const chosenType = malfunctionTypes.find((type) => type.malfunctionTypeId === event.value);
      this.form.get('malfunctionTypeName').patchValue(chosenType.malfunctionTypeName);
    });
  }

  onMalfunctionDateChange(event: any) {
    if (this.form.get('personnelId').value) {
      const formattedDate = new Date(event.value).toISOString()
      this.jumperSub = this.dropdownService.getJumperById(this.form.get('personnelId').value, formattedDate).subscribe({
        next: (jumper) => {
          this.form.get('jumperDetails').patchValue(jumper);
        }
      });
    }
  }

  onSpikeBaseChange(event: any) {
    this.spikebaseSub = this.spikeBases$.subscribe((bases) => {
      const base = bases.find((base) => event.value === base.id);
      this.form.get('spikeBaseDetails').patchValue(base);
    })
  }

  onBaseChange(event: any) {
    this.form.get('spikeBaseId').patchValue(null);
    if (this.form.get('spikeBaseId').status === 'DISABLED') {
      this.form.get('spikeBaseId').enable({ emitEvent: false });
    }
    const base = this.homeBases.find((base: any) =>  this.form.get('homeBase1').value === base.baseCode )
    this.form.get('homeBase1Details').patchValue(base);
    this.form.get('homeBaseId').patchValue(base.id);
    this.spikeBases$ = this.dropdownService
      .getSpikeBases(event.value)
      .pipe(map((response) => response.value));
  }

  // this filters down the select list for the madb incident input
  onMadbIncidentInput(event: any) {
    this.incidentService.getMadbIncidentsFilteredByString(event.target.value);
  }

  checkClassification(event: any) {
    if (event.value === 1) {
      this.form.get('classificationName').patchValue('Jumper Related');
    } else if (event.value === 2) {
      this.form.get('classificationName').patchValue('Paracargo Related');
    } else if (event.value === 3) {
      this.form.get('classificationName').patchValue('Aircraft Related');
    }
    
    const classificationId = this.form.get('classificationId').value;
    const categoryId = this.form.get('categoryId').value;
    if (classificationId !== null && categoryId !== null) {
      this.form.get('categoryId').patchValue(null);
    }
  }

  checkClassificationType(event: any) {
    if (event.value === 1) {
      this.form.get('classificationTypeName').patchValue('Parachute');
    } else if (event.value === 2) {
      this.form.get('classificationTypeName').patchValue('Gear / Equipment');
    } else if (event.value === 3) {
      this.form.get('classificationTypeName').patchValue('Procedure');
    }

    const classificationTypeId = this.form.get('classificationTypeId').value;
    const categoryId = this.form.get('categoryId').value;
    if (classificationTypeId !== null && categoryId !== null) {
      this.form.get('categoryId').patchValue(null);
    }
  }

  onCategoryChange(event: any) {
    const selectedCategory = this.categories$.value.find(
      (category) => category.categoryId === event.value
    );
    this.form.get('categoryName').patchValue(selectedCategory.categoryName);
    this.form.get('malfunctionTypeId').patchValue(0);
  }

  setMadbIncident(event: any) {
    this.madbIncidentSub = this.incidentService
      .getSingleMadbIncident(event?.option?.value?.incidentId || event)
      .subscribe((madbIncident) => {
        let newMadbIncident = {...madbIncident,
          incidentId: madbIncident._id,
          incidentName: madbIncident._nameofIncident,
          baseCode: madbIncident._baseCode,
        }
        // this finds the aircraft object from the list of aircraft by checking the aircraft id against the madbIncident.aircraftId
        this.selectedAircraftSub = this.aircrafts$.subscribe((aircrafts) => {
          const aircraft = aircrafts?.filter((aircraft) => aircraft.id === madbIncident._methodOfTravel_Id)[0] || null;
          this.form.get('aircraft')?.patchValue(aircraft);
          this.form.get('travelModeId').patchValue(madbIncident._methodOfTravel_Id);
        })
        this.form.get('madbIncident').patchValue(newMadbIncident);
        this.form.get('madbIncidentId').patchValue(event.option.value.incidentId);
        this.form.get('mission').patchValue(madbIncident._mission);
        this.form.get('mode').patchValue(madbIncident._mode);
        this.form.get('toAreaName').patchValue(null);
        this.form.get('toArea').patchValue(madbIncident._areaId);
        this.form.get('yardsDrift').patchValue(madbIncident._yardsofDrift);
      });
  }

  clearMadbData() {
    this.dialogService
      .openDialog(
        {
          title: 'Clear Master Action Data',
          message: 'Confirming this action will clear the data of the following fields:'
        },
        ConfirmDialogComponent
      )
      .subscribe((result) => {
        if (result) {
          this.madbIncidentCtrl.patchValue(null);
          this.form.get('madbIncident').patchValue(null);
          this.form.get('madbIncidentId').patchValue(null);
          this.form.get('mission').patchValue(null);
          this.form.get('mode').patchValue(null);
          this.form.get('toArea').patchValue(0);
          this.form.get('toAreaName').patchValue(null);
          this.form.get('yardsDrift').patchValue(null);
          this.form.get('aircraft').patchValue(null);
          this.form.get('travelModeId').patchValue(null);
        }
      });
  }

  confirmDeleteIncident = (incident) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this incident?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        incident: incident
      },
      active: true
    };
  };

  deleteIncident = async (incident) => {
    this.deleteIncidentSub = this.incidentService.deleteIncident(incident).subscribe({
      next: (response) => {
        this.toast.show('Deleted Incident', 'success');
        this.router.navigate(['mars/search']);
      },
      error: (error) => {
        this.toast.show('Error deleting Incident', 'error');
      }
    });
  };

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.deleteIncident(data.incident);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  ngOnDestroy(): void {
    this.categories$?.complete();
    this.classficationSub?.unsubscribe();
    this.homeBaseSub?.unsubscribe();
    this.madbIncidentListSub?.unsubscribe();
    this.madbIncidentSub?.unsubscribe();
    this.aircraftSub?.unsubscribe();
    this.spikebaseSub?.unsubscribe();
    this.jumperSubscription?.unsubscribe();
    this.jumperSub?.unsubscribe();
    this.deleteIncidentSub?.unsubscribe();
    this.statusSub?.unsubscribe();
    this.elevationSub?.unsubscribe();
    this.aircraftsSubscription?.unsubscribe();
    this.selectedAircraftSub?.unsubscribe();
    this.aircraftsSub?.unsubscribe();
    this.malfunctionTypeSub?.unsubscribe();
    this.areaSub?.unsubscribe();
    this.areasSub?.unsubscribe();
    this.homeBasesSub?.unsubscribe();
    this.madbIncidentSubscription?.unsubscribe();
    this.formService.marsMadbIncident.next(null);
    this.form.reset();
  }
}
